import { colors } from '../../shared/theme/colors';

/** Métricas derivadas para informe ventas por producto (solo cliente; sin RPC extra). */

export function pctOfTotal(part: number, total: number): number | null {
  if (!Number.isFinite(part) || !Number.isFinite(total) || total <= 0) return null;
  return (part / total) * 100;
}

export function avgUnitPrice(lineTotal: number, quantity: number): number | null {
  if (quantity <= 0 || !Number.isFinite(lineTotal)) return null;
  return lineTotal / quantity;
}

export function unitsPerDay(quantity: number, daysInRange: number): number | null {
  if (daysInRange <= 0 || !Number.isFinite(quantity)) return null;
  return quantity / daysInRange;
}

export function formatPct1(value: number | null): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${value.toFixed(1)}%`;
}

export function formatMoney0(n: number): string {
  return n.toLocaleString('es-AR', { maximumFractionDigits: 0 });
}

export function formatMoney2(n: number): string {
  return n.toLocaleString('es-AR', { maximumFractionDigits: 2 });
}

export type AbcClass = 'A' | 'B' | 'C';

export function abcClassFromCumulativePct(cumulativePct: number): AbcClass {
  if (cumulativePct <= 80) return 'A';
  if (cumulativePct <= 95) return 'B';
  return 'C';
}

export function abcClassColor(abcClass: AbcClass): string {
  if (abcClass === 'A') return colors.success;
  if (abcClass === 'B') return colors.warning;
  return colors.textMuted;
}

/**
 * Clasificación ABC sobre el listado ya ordenado por importe descendente.
 * Devuelve, para cada fila, la clase y el porcentaje acumulado de contribución al importe total.
 */
export function computeAbcSeries(rows: Array<{ lineTotal: number }>, total: number, startAccumulated = 0): Array<{
  abcClass: AbcClass;
  cumulativePct: number;
  contributionPct: number | null;
}> {
  if (!Number.isFinite(total) || total <= 0) {
    return rows.map(() => ({ abcClass: 'C' as AbcClass, cumulativePct: 0, contributionPct: null }));
  }
  let accumulated = startAccumulated;
  return rows.map((row) => {
    const contributionPct = (row.lineTotal / total) * 100;
    accumulated += contributionPct;
    return {
      abcClass: abcClassFromCumulativePct(accumulated),
      cumulativePct: accumulated,
      contributionPct,
    };
  });
}
